module.exports = __webpack_public_path__ + "static/media/AppsIllustration.301f77fe.svg";